import { Star } from "lucide-react";
import { REVIEWS } from "../lib/constants";

export function Reviews() {
  return (
    <section className="section reviews-section" data-testid="reviews-section">
      <div className="section-heading" data-testid="reviews-heading">
        <span className="section-eyebrow" data-testid="reviews-eyebrow">Confiança local</span>
        <h2 data-testid="reviews-title">Avaliações de clientes</h2>
        <p data-testid="reviews-description">Cards editáveis com aparência de avaliações locais, sem uso indevido de marca oficial ou schema de reviews não verificados.</p>
      </div>
      <div className="reviews-grid" data-testid="reviews-grid">
        {REVIEWS.map((review, index) => (
          <article className="review-card" key={review.name} data-testid={`review-card-${index}`}>
            <div className="stars" aria-label="cinco estrelas" data-testid={`review-stars-${index}`}>{Array.from({ length: 5 }).map((_, i) => <Star key={i} size={18} fill="currentColor" />)}</div>
            <p data-testid={`review-text-${index}`}>“{review.text}”</p>
            <strong data-testid={`review-name-${index}`}>— {review.name}</strong>
            <small data-testid={`review-date-${index}`}>{review.date}</small>
          </article>
        ))}
      </div>
    </section>
  );
}